import React, { createContext, useContext } from 'react'

const SidebarContext = createContext()

export const useSidebar = () => {
  const context = useContext(SidebarContext)
  if (!context) {
    // means we are mobile
    return { setOpen: () => {} }
  }
  return context
}

export const SidebarProvider = ({ children, setOpen }) => {
  return (
    <SidebarContext.Provider value={{ setOpen }}>
      {children}
    </SidebarContext.Provider>
  )
}
